<template>
  <div class="wrapper">
    <AdminBreadCrumb :list="[parentPage]" title="マップレポート管理" />
    <v-container ma-0 fluid>
      <WhiteSection class="mb-3 pa-0">
        <v-layout justify-start align-center>
          <slot />
        </v-layout>
        <v-layout justify-end align-center>
          <v-toolbar flat color="white">
            <v-btn @click="openCheckModal" class="black--text"
              >発行待ちレポートの自動発行Jobを開く</v-btn
            >
            <v-spacer />
            発行ステータス
            <SearchStatus
              @onStatusChange="onStatusChange"
              style="margin-right: 20px; margin-left: 10px"
            />
            発行方法
            <SearchAutoGenerateStatus
              @onAutoGenerateStatusChange="onAutoGenerateStatusChange"
              style="margin-right: 20px; margin-left: 10px"
            />
            <SearchKeyword @onTextEnter="onTextEnter" class="margin-left" />
            <PageSelect
              :value="mapReport"
              @input="pagination"
              style="width: 160px"
              class="pl-4"
            />
          </v-toolbar>
          <v-dialog
            v-if="isOpenCheckModal"
            v-model="isOpenCheckModal"
            persistent
            max-width="1500px"
            style="color: white"
          >
            <v-card>
              <v-card-title style="margin-left: 20px"
                ><span class="headline"
                  >自動発行マップレポート一覧</span
                ></v-card-title
              >
              <p style="padding-left: 37px">
                自動発行件数：{{ autogeneratedPendingRequests.length }} 件
              </p>
              <v-data-table
                v-if="autogeneratedPendingRequests.length > 0"
                :headers="headers"
                :items="autogeneratedPendingRequests"
                :fixed-header="true"
                style="margin-left: 50px; margin-right: 50px;"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center pa-0">{{ props.item.id }}</td>
                  <td class="text-xs-left pa-2">{{ props.item.name }}</td>
                  <td class="text-xs-left pa-2">
                    {{ props.item.insertionOrderName }}
                  </td>
                  <td class="text-xs-left pa-2">
                    {{ props.item.advertiserName }}
                  </td>
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="closeCheckModal">キャンセル</v-btn>
                <v-btn
                  @click="closeCheckModal"
                  :disabled="autogeneratedPendingRequests.length === 0"
                  color="primary"
                  href="http://gl-rdops.geo-logic.jp/project/geologic-ad/job/show/86d92baa-5763-4644-b8de-3ffa5fd90110"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  自動発行画面へ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </WhiteSection>
      <AdminMapReportList :items="mapReport.items" />
    </v-container>
  </div>
</template>

<script>
import AdminBreadCrumb from '@/components/Shared/BreadCrumb/AdminBreadCrumb'
import SearchStatus from '@/components/Admin/Request/AdminMapReport/AdminMapReportListSearchStatus'
import SearchAutoGenerateStatus from '@/components/Admin/Request/AdminMapReport/AdminMapRerpotListSearchAutoGenerateStatus'
import SearchKeyword from '@/components/Admin/Request/AdminMapReport/AdminMapReportListSearchKeyWord'
import AdminMapReportList from '@/components/Admin/Request/AdminMapReport/AdminMapReportList'
import PageSelect from '@/components/Shared/Search/PageSelect'
import WhiteSection from '@/components/Shared/Section/Section'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import { mapActions, mapGetters } from 'vuex'
import { MapReportListRepository } from '@/models/MapReport'

export default {
  name: 'AdminMapReportRequest',
  components: {
    AdminBreadCrumb,
    WhiteSection,
    SearchStatus,
    SearchAutoGenerateStatus,
    SearchKeyword,
    AdminMapReportList,
    PageSelect,
  },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      mapReportObject: {},
      isOpenCheckModal: false,
      headers: [
        { text: 'ID', value: 'id', class: 'px-2' },
        { text: 'レポート名', value: 'name', class: 'px-3' },
        { text: '案件名', value: 'insertionOrderName', class: 'px-3' },
        { text: '広告主名', value: 'advertiserName', class: 'px-3' },
      ],
      autogeneratedPendingRequests: [],
    }
  },
  computed: {
    ...mapGetters('mapReportForAdmin', [
      'keyword',
      'status',
      'isAutoGenerated',
      'pageNo',
      'mapReport',
    ]),
    parentPage() {
      return { path: null, title: '承認管理' }
    },
  },
  created() {
    this.initSearch()
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    ...mapActions('mapReportForAdmin', {
      initSearchItems: 'INIT_SEARCH_ITEMS',
      setSearchKeyword: 'SET_SEARCH_KEYWORD',
      setPageNo: 'SET_SEARCH_PAGE_NO',
      setSearchStatus: 'SET_SEARCH_STATUS',
      setSetGenerateStatus: 'SET_SEARCH_AUTO_GENERATE_STATUS',
      setMapReport: 'SET_MAP_REPORT',
      reset: 'RESET',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    updateMapReport() {
      this.setMapReport({
        keyword: this.keyword,
        status: this.status,
        isAutoGenerated: this.isAutoGenerated,
        pageNo: this.pageNo,
      })
    },
    initSearch() {
      this.initSearchItems()
      this.updateMapReport()
    },
    onStatusChange(searchStatus) {
      this.setSearchStatus(searchStatus)
      this.updateMapReport()
    },
    onAutoGenerateStatusChange(AutoGenerateStatusChange) {
      this.setSetGenerateStatus(AutoGenerateStatusChange)
      this.updateMapReport()
    },
    onTextEnter(searchWord) {
      this.setSearchKeyword(searchWord)
      this.updateMapReport()
    },
    pagination(pageNo) {
      this.setPageNo(pageNo)
      this.updateMapReport()
    },
    async openCheckModal() {
      this.isOpenCheckModal = true
      this.autogeneratedPendingRequests = await this.getAllPendingAutoGeneratedRequests()
    },
    closeCheckModal() {
      this.isOpenCheckModal = false
    },
    async getAllPendingAutoGeneratedRequests() {
      const response = await MapReportListRepository.getMapReportForAdmin(
        undefined,
        'waiting',
        true,
        1,
        99999,
      )
      return response.items
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.margin-left {
  margin-left: 20px;
}
</style>
